import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "admin-config-branches__branch" }
const _hoisted_2 = {
  class: "name",
  style: {"margin-bottom":"10px"}
}
const _hoisted_3 = {
  class: "branch-flags",
  style: {"margin-bottom":"10px"}
}
const _hoisted_4 = { class: "slug" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"10px"} }, " Dieser Slug wird für die URL in der Preisanzeige verwendet. ", -1)
const _hoisted_6 = {
  class: "categories",
  style: {"margin-bottom":"10px"}
}
const _hoisted_7 = {
  key: 0,
  class: "categories-dynamic"
}
const _hoisted_8 = ["for"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " Wenn keine ausgewählt, werden alle ausgegeben ", -1)
const _hoisted_12 = ["for"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "icons" }
const _hoisted_16 = ["for"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "url",
  style: {"margin-top":"10px"}
}
const _hoisted_19 = { class: "colors" }
const _hoisted_20 = ["for"]
const _hoisted_21 = { class: "colors__color" }
const _hoisted_22 = { class: "colors__color" }
const _hoisted_23 = { class: "images" }
const _hoisted_24 = { class: "images__priceshow" }
const _hoisted_25 = {
  class: "url",
  style: {"margin-bottom":"10px"}
}
const _hoisted_26 = { class: "url" }

import slugify from '@/utils/slugify.ts';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  computed,
  onBeforeMount,
  watch,
} from 'vue';
import InputField from '@/components/form/Input.vue';
import MediaField from '@/components/form/MediaField.vue';
import SelectField from '@/components/form/Select.vue';
import Checkbox from '@/components/form/Checkbox.vue';
import ProductCategoryInterface from '@/interfaces/ProductCategoryInterface';
import BranchConfigurationInterface from '@/interfaces/BranchConfigurationInterface';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTrashCan,
} from '@fortawesome/pro-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminConfigBranchesBranch',
  props: /*#__PURE__*/_mergeModels({
    index: {},
    numBranches: {},
    categories: {}
  }, {
    "modelValue": {
  required: true,
},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(["delete"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

library.add(faTrashCan);

const configuredBranch = _useModel<BranchConfigurationInterface>(__props, "modelValue");
const props = __props;

const emit = __emit;

const categoryOptions = computed(() => props.categories.map((categ) => ({
  value: categ.id,
  label: categ.name,
})));

const dynamicTariffOptions = [
  { value: 'disabled', label: 'Dynamische Tarife nicht ausgeben' },
  { value: 'enabled', label: 'Normale und dynamische Tarife ausgeben' },
  { value: 'only', label: 'Nur dynamische Tarife ausgeben' },
];

const onUpdateCategory = (value: string) => {
  configuredBranch.value.category = props.categories.find((categ) => categ.id === parseInt(value, 10));
  configuredBranch.value.subcategories = [];
  configuredBranch.value.subcategoriesExcept = [];
  configuredBranch.value.iconOrImage = undefined;
};

watch(() => configuredBranch.value.name, (value) => {
  configuredBranch.value.slug = value;
});

watch(() => configuredBranch.value.slug, (value, oldValue) => {
  if (value !== oldValue) {
    configuredBranch.value.slug = slugify(`${value || ''}`.trim());
  }
});

const toggleSelectSubcategory = (category: {
  value: number,
  label: string
}) => {
  const isCurrentlySelected = configuredBranch.value.subcategories.filter((categ) => categ.id === category.value).length >= 1;

  if (isCurrentlySelected) {
    configuredBranch.value.subcategories = configuredBranch.value.subcategories.filter((sc) => sc.id !== category.value);
  } else {
    const mainCateg = props.categories.find((categ) => categ.id === configuredBranch.value.category?.id);
    const categToAdd = (mainCateg?.children || []).find((categ) => categ.id === category.value);

    if (categToAdd) {
      configuredBranch.value.subcategories.push(categToAdd);
    }
  }
};

const toggleSelectSubcategoryExcept = (category: {
  value: number,
  label: string
}) => {
  if (!Array.isArray(configuredBranch.value.subcategoriesExcept)) {
    configuredBranch.value.subcategoriesExcept = [];
  }

  const isCurrentlySelected = configuredBranch.value.subcategoriesExcept.filter((categ) => categ.id === category.value).length >= 1;

  if (isCurrentlySelected) {
    configuredBranch.value.subcategoriesExcept = configuredBranch.value.subcategoriesExcept.filter((sc) => sc.id !== category.value);
  } else {
    const mainCateg = props.categories.find((categ) => categ.id === configuredBranch.value.category?.id);
    const categToAdd = (mainCateg?.children || []).find((categ) => categ.id === category.value);

    if (categToAdd) {
      configuredBranch.value.subcategoriesExcept.push(categToAdd);
    }
  }
};

const subcategoryOptions = computed<{
  value: number;
  label: string;
}[]>(() => {
  const options = [] as any[];

  if (configuredBranch.value.category?.children) {
    const addWithLevel = (category: ProductCategoryInterface, level = 0) => {
      options.push({
        value: category.id,
        label: `${'-'.repeat(level)} ${category.name}`,
      });

      category.children.forEach((child) => {
        addWithLevel(child, level + 1);
      });
    };

    configuredBranch.value.category.children.forEach((categ) => {
      addWithLevel(categ);
    });
  }

  return options;
});

const canHaveDynamicTariffs = computed(() => configuredBranch.value.category?.key === 'power');

const selectableIcons = computed<ProductCategoryInterface[]>(() => [
  configuredBranch.value.category,
  ...configuredBranch.value.subcategories,
].filter((c) => c && (c?.icon || c?.image)) as ProductCategoryInterface[]);

const selectIcon = (categoryId: number) => {
  if (configuredBranch.value.iconOrImage === categoryId) {
    configuredBranch.value.iconOrImage = undefined;

    return;
  }

  configuredBranch.value.iconOrImage = categoryId;
};

onBeforeMount(() => {
  // migrate old branches
  if (!configuredBranch.value.dynamicTariffs) {
    configuredBranch.value.dynamicTariffs = 'disabled';
  }
  if (configuredBranch.value.isGlobal === undefined) {
    configuredBranch.value.isGlobal = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.numBranches > 1)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "delete",
          type: "button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('delete', _ctx.index)), ["prevent"]))
        }, [
          _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faTrashCan) }, null, 8, ["icon"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InputField, {
        label: "Sparten-Name",
        modelValue: configuredBranch.value.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((configuredBranch.value.name) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Checkbox, {
        label: "Dient lediglich zur Weiterleitung auf URL",
        modelValue: configuredBranch.value.isUrl,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((configuredBranch.value.isUrl) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(Checkbox, {
        label: "Branch im globalen mobilen Preisrechner anzeigen?",
        modelValue: configuredBranch.value.isGlobal,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((configuredBranch.value.isGlobal) = $event))
      }, null, 8, ["modelValue"]),
      (configuredBranch.value.isGlobal)
        ? (_openBlock(), _createBlock(InputField, {
            key: 0,
            type: "number",
            style: {"min-width":"240px"},
            placeholder: "Position im mobilen Preisrechner",
            modelValue: configuredBranch.value.globalPosition,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((configuredBranch.value.globalPosition) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    (!configuredBranch.value.isUrl)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(InputField, {
              label: "Sparten-Slug",
              modelValue: configuredBranch.value.slug,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((configuredBranch.value.slug) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(SelectField, {
              label: "Hauptkategorie",
              options: categoryOptions.value,
              "model-value": configuredBranch.value.category?.id,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (onUpdateCategory($event)))
            }, null, 8, ["options", "model-value"])
          ]),
          (canHaveDynamicTariffs.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(SelectField, {
                  label: "Dynamische Tarife",
                  options: dynamicTariffOptions,
                  modelValue: configuredBranch.value.dynamicTariffs,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((configuredBranch.value.dynamicTariffs) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(), _createElementBlock("div", {
            class: "subcategories",
            key: `subcategories--${configuredBranch.value.category ? configuredBranch.value.category.id : 0}`
          }, [
            _createElementVNode("label", {
              for: `sub-category-${configuredBranch.value.category?.id || '#'}`
            }, " Unterkategorien ", 8, _hoisted_8),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subcategoryOptions.value, (category) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `sub-category-${category.value}`,
                class: _normalizeClass({ selected: configuredBranch.value.subcategories.filter((categ) => categ.id === category.value).length }),
                onClick: ($event: any) => (toggleSelectSubcategory(category))
              }, _toDisplayString(category.label), 11, _hoisted_9))
            }), 128)),
            (subcategoryOptions.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Keine aktive Unterkategorie vorhanden. "))
              : _createCommentVNode("", true),
            _hoisted_11
          ])),
          (_openBlock(), _createElementBlock("div", {
            class: "subcategories",
            key: `subcategories--${configuredBranch.value.category ? configuredBranch.value.category.id : 0}`
          }, [
            _createElementVNode("label", {
              for: `sub-category-exclude-${configuredBranch.value.category?.id || '#'}`
            }, " Unterkategorien explizit ausschließen ", 8, _hoisted_12),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subcategoryOptions.value, (category) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `sub-category-exclude-${category.value}`,
                class: _normalizeClass({ selected: (configuredBranch.value.subcategoriesExcept || []).filter((categ) => categ.id === category.value).length }),
                onClick: ($event: any) => (toggleSelectSubcategoryExcept(category))
              }, _toDisplayString(category.label), 11, _hoisted_13))
            }), 128)),
            (subcategoryOptions.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Keine aktive Unterkategorie vorhanden. "))
              : _createCommentVNode("", true)
          ])),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", {
              for: `icon-${configuredBranch.value.category?.id || '#'}`
            }, " Sparten Icon ", 8, _hoisted_16),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectableIcons.value, (category) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${configuredBranch.value.id}-category-${category.id}`
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass({
                icon: category.icon,
                image: category.image,
                selected: category.id === configuredBranch.value.iconOrImage,
              }),
                    style: _normalizeStyle({ 'background-color': category.color }),
                    onClick: ($event: any) => (selectIcon(category.id))
                  }, [
                    (category.image)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          style: _normalizeStyle(`background-image: url(${category.image.url})`)
                        }, null, 4))
                      : (category.icon)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: _normalizeStyle({ color: category.iconColor })
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(category.icon)
                            }, null, 2)
                          ], 4))
                        : _createCommentVNode("", true)
                  ], 14, _hoisted_17)
                ]))
              }), 128))
            ])
          ]),
          (!configuredBranch.value.iconOrImage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(MediaField, {
                  label: "Benutzerdefiniertes Icon",
                  modelValue: configuredBranch.value.customIconOrImage,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((configuredBranch.value.customIconOrImage) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", {
              for: `colors-${configuredBranch.value.category?.id || '#'}`
            }, " Sparten Farben ", 8, _hoisted_20),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", {
                  class: "colors__color--primary",
                  style: _normalizeStyle({
                backgroundColor: configuredBranch.value.customColor.primary,
              })
                }, null, 4),
                _createVNode(InputField, {
                  label: "Sparten Farbe primär",
                  modelValue: configuredBranch.value.customColor.primary,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((configuredBranch.value.customColor.primary) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", {
                  class: "colors__color--secondary",
                  style: _normalizeStyle({
                backgroundColor: configuredBranch.value.customColor.secondary,
              })
                }, null, 4),
                _createVNode(InputField, {
                  label: "Sparten Farbe sekundär",
                  modelValue: configuredBranch.value.customColor.secondary,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((configuredBranch.value.customColor.secondary) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(MediaField, {
                label: "Hero Bild Preisanzeige",
                modelValue: configuredBranch.value.images.priceshow,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((configuredBranch.value.images.priceshow) = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (configuredBranch.value.isUrl)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(InputField, {
              label: "URL",
              modelValue: configuredBranch.value.url,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((configuredBranch.value.url) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(InputField, {
              label: "Benutzerdefiniertes Icon (SVG Code oder Fontawesome 6)",
              modelValue: configuredBranch.value.customIcon,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((configuredBranch.value.customIcon) = $event))
            }, null, 8, ["modelValue"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})